module.exports = __webpack_public_path__ + "img/overall-situation-loading.af344ade.png";